import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'rs-web-navigation-user-profile',
  templateUrl: './navigation-user-profile.component.html',
  styleUrls: ['./navigation-user-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationUserProfileComponent {
  name = input<string>();
  email = input<string>();
  // portrait = input<Attachment>();
  dark = input<boolean>();
}
